import { apiClient } from './client';
import { unwrapList } from './unwrap';
import type { PagedResult, ReportRecord, TriggerReportRequest } from './types';

export const reportsApi = {
  /**
   * Generic async report flow (POST /api/v1/reports, GET /api/v1/reports/{id},
   * GET /api/v1/reports?competitionId=).
   */
  trigger: (payload: TriggerReportRequest) =>
    apiClient.post<ReportRecord>('/reports', payload).then((r) => r.data),

  getById: (id: string) => apiClient.get<ReportRecord>(`/reports/${id}`).then((r) => r.data),

  listByCompetition: (competitionId: string) =>
    apiClient
      .get('/reports', { params: { competitionId } })
      .then((r) => unwrapList<ReportRecord>(r.data)) as Promise<PagedResult<ReportRecord>>,
};
